import { gql } from '@apollo/client';

export const GetFindGroupQueryName = 'GetFindGroup';

export const GET_FIND_GROUP_QUERY = gql`
  query ${GetFindGroupQueryName}($id: String!) {
    getFindGroup(id: $id) {
      id
      createdAt
      createdBy
      createdByName
      createdByEmail
      name
      description
      shared
      level
      collaborators {
        id
        createdAt
        userId
        groupId
        level
        email
        displayName
      }
    }
  }
`;
